<template>
  <div class="home">
    <div class="banner" ref="section1">
      <div class="area">
        <div class="title_1">
          智呈可视化分析平台
        </div>
        <div class="title_2">
          数据洞察，智慧呈现
        </div>
        <div class="describe">
          改变了传统的数据大屏制作模式，致力于帮助企业能够以更便捷、更高效的方式展现数据价值。
        </div>
      </div>
      <div :class="{ 'nav': true, 'opaque': isOpaque }">
        <img src="./images/logo.png" style="margin: 20px 0 0 150px;">
        <ul>
          <li @click="scrollToSection('section1')">首页</li>
          <li @click="scrollToSection('section2')">解决问题</li>
          <li @click="scrollToSection('section3')">功能介绍</li>
          <li @click="scrollToSection('section4')">商务合作</li>
          <li @click="scrollToSection('section5')">关于我们</li>
        </ul>
      </div>
    </div>
    <div class="main" ref="section2">
      <div class="center">
        <span style="font-size: 56px;text-align: center;display: block;margin-bottom: 50px;">解决问题</span>
        <ul>
          <li>
            <img src="./images/problem01.png">
            <span>数据孤岛现象严重。企业内部各部门使用独立系统，数据分散存储，导致数据无法共享与协同分析。</span>
            <div class="mask">
              智呈可视化分析平台凭借强大的数据连接与整合功能，支持接入多种数据源，如数据库、文件、云存储等。它能将分散在不同系统中的数据集中采集与整合，打破数据孤岛。
            </div>
          </li>
          <li>
            <img src="./images/problem02.png">
            <span>数据质量参差不齐。数据来源广泛且缺乏规范管理时，会出现数据错误、重复、缺失等质量问题，影响分析结果准确性。</span>
            <div class="mask">
              智呈平台提供数据清洗和预处理功能，可自动识别并处理异常数据。平台还支持数据质量监控，实时反馈数据质量状况，方便及时发现并解决问题。
            </div>
          </li>
          <li>
            <img src="./images/problem03.png">
            <span>数据分析时效性不强。数据变化迅速，传统数据分析流程复杂、耗时，导致分析结果滞后，无法及时支持决策。</span>
            <div class="mask">
              智呈平台具备实时数据处理能力，可实时采集和分析数据。通过设置实时预警功能，一旦数据出现异常波动或达到预设阈值，能及时通知相关人员。
            </div>
          </li>
          <li>
            <img src="./images/problem04.png">
            <span>数据安全无法保证。智呈平台建立严格的权限管理机制，为不同用户分配不同权限，确保只有授权人员能访问和操作特定数据。</span>
            <div class="mask">
              智呈平台建立严格的权限管理机制，为不同用户分配不同权限，确保只有授权人员能访问和操作特定数据。平台采用加密技术，对数据传输和存储进行加密处理，防止数据被窃取或篡改。
            </div>
          </li>
          <li>
            <img src="./images/problem05.png">
            <span>数据使用成本过高。购买专业数据分析软件、组建技术团队等成本高昂，给企业带来经济压力。</span>
            <div class="mask">
              智呈平台采用零编码、低编码操作模式，降低对专业技术人员的依赖，减少人力成本。
            </div>
          </li>
        </ul>
        <div class="enterPage" @click="enterPage()">
          免费试用
        </div>
      </div>
      <div class="introduce" ref="section3">
        <div class="center">
          <span style="font-size: 56px;text-align: center;display: block;margin-bottom: 50px;">功能介绍</span>
          <div class="article">
            <div class="left">
              <div class="title">
                零编码/低编码操作
              </div>
              <div class="content">
                智呈平台最大的亮点之一就是无需编码或仅需少量代码即可完成数据大屏的开发。传统的数据大屏开发往往依赖专业的程序员，耗费大量的时间和人力成本。而智呈平台采用画布式界面，用户只需通过简单的拖拽式操作，就能轻松进行数据的处理和模板的制作。无论是业务人员还是非技术出身的管理人员，都能迅速上手，大大降低了数据大屏开发的门槛。
              </div>
            </div>
            <div class="right">
              <img src="./images/introduce.png">
            </div>
          </div>
          <div class="article">

            <div class="right">
              <img src="./images/introduce.png">
            </div>
            <div class="left">
              <div class="title">
                丰富的数据处理能力
              </div>
              <div class="content">
                平台支持多种数据源接入，包括常见的数据库（如 MySQL、Oracle 等）、文件（如 Excel、CSV
                等）以及各类云存储服务。接入数据后，用户可以在平台上对数据进行清洗、转换、聚合等操作。例如，通过简单的设置，就可以将不同数据源中的数据按照特定规则进行合并，或者对数据进行筛选、排序，提取出关键信息。强大的数据处理能力确保了用户能够从原始数据中挖掘出有价值的信息，并将其呈现在数据大屏上。
              </div>
            </div>
          </div>
          <div class="article">
            <div class="left">
              <div class="title">
                多样化的可视化组件
              </div>
              <div class="content">
                智呈平台提供了丰富多样的可视化组件，涵盖柱状图、折线图、饼图、地图、仪表盘等常见图表类型，以及一些独特的可视化元素，如数据魔方、时间轴等。每个组件都经过精心设计，具有美观的视觉效果和良好的交互性。用户可以根据数据的特点和展示需求，选择合适的可视化组件进行拖拽添加，并通过简单的参数设置，自定义组件的样式、颜色、数据映射等属性。通过组合不同的可视化组件，用户能够打造出极具个性和吸引力的数据大屏。
              </div>
            </div>
            <div class="right">
              <img src="./images/introduce.png">
            </div>
          </div>
          <div class="article">

            <div class="right">
              <img src="./images/introduce.png">
            </div>
            <div class="left">
              <div class="title">
                灵活的模板制作
              </div>
              <div class="content">
                除了直接创建数据大屏，智呈平台还支持模板制作。用户可以将自己制作的数据大屏保存为模板，方便在后续项目中重复使用。模板不仅包含可视化组件的布局和样式，还可以保存数据处理的逻辑和配置。这意味着，当用户需要制作多个类似的数据大屏时，只需基于已有的模板进行简单修改，就能快速生成新的大屏，大大提高了工作效率。同时，平台还提供了一些预设的模板库，用户可以从中选择适合自己业务场景的模板进行修改和定制，进一步加快数据大屏的制作速度。
              </div>
            </div>
          </div>
          <div class="article">
            <div class="left">
              <div class="title">
                终端用户自主开发
              </div>
              <div class="content">
                平台允许终端用户使用易于理解的可视化工具开发自己的应用程序。这意味着，企业内部的业务人员可以根据自己的业务需求，自行创建数据大屏，而无需依赖外部技术团队。用户可以在平台上构建业务流程、逻辑和数据模型等所需的功能。例如，通过设置条件判断、数据计算等逻辑，实现数据的动态展示和分析。在必要时，用户还可以添加自己的代码，以满足一些特殊的业务需求。这种终端用户自主开发的模式，不仅提高了数据大屏开发的效率和灵活性，还能够更好地满足企业个性化的业务需求。
              </div>
            </div>
            <div class="right">
              <img src="./images/introduce.png">
            </div>
          </div>
        </div>
      </div>
      <div class="partner" ref="section4">
        <div class="center">
          <span style="font-size: 56px;text-align: center;display: block;margin-bottom: 50px;">商务合作</span>
          <div class="collaborationMode">
            <div class="square">
              <img src="./images/circle1.png">
              <div class="title">
                产品定制服务
              </div>
              <div class="content">
                根据企业的具体需求，对平台进行个性化定制开发。无论是特殊的数据处理需求、独特的可视化组件设计，还是与企业现有系统的深度集成，我们的专业团队都能为您提供完美契合企业的业务流程的解决方案。
              </div>
            </div>
            <div class="square">
              <img src="./images/circle2.png">
              <div class="title">
                技术支持与培训
              </div>
              <div class="content">
                为了帮助企业更好地使用智呈可视化大屏工具数据平台，我们提供全方位的技术支持与培训服务。涵盖平台的基本操作、数据处理技巧、可视化设计方法以及高级功能应用等方面。通过培训，让企业员工能够熟练掌握平台的使用方法，充分发挥平台的优势。
              </div>
            </div>
            <div class="square">
              <img src="./images/circle3.png">
              <div class="title">
                合作伙伴计划
              </div>
              <div class="content">
                我们将提供的技术支持、市场推广资源、销售培训等全方位的支持。我们将与您携手，共同为客户提供优质的数据可视化解决方案，推动行业的发展。
              </div>
            </div>
            <div class="enterPage" @click="dialogFormVisible = true">
              联系我们
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer" ref="section5">
      <div class="center">
        <div class="left">
          <img src="./images/zbys.png">
          <span style="font-size: 22px;font-weight: bold;margin-bottom: 20px;">北京智步云上科技有限公司</span>
          <span>电话：130-5185-0850</span>
          <span>地址：北京市昌平区北清路1号院8号楼21层1单元2107</span>
        </div>
        <div class="right">
          <img src="./images/erweima.png">
          <span>扫码了解更多</span>
        </div>
        <div class="bottom">北京智步云上科技有限公司 备案/许可证编号：京ICP备2024066658号</div>
      </div>
    </div>
    <el-dialog title="联系我们" :visible.sync="dialogFormVisible" width="700px">
      <el-form :model="form">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.name" placeholder="请输入姓名" autocomplete="off" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="电话" :label-width="formLabelWidth">
          <el-input v-model="form.num" placeholder="请输入电话" autocomplete="off" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="form.mail" placeholder="请输入邮箱" autocomplete="off" style="width: 300px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const isOpaque = ref(false);

const handleScroll = () => {
  if (window.scrollY > 800) {
    isOpaque.value = true;
  } else {
    isOpaque.value = false;
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>
<script>
export default {
  name: "home",
  data() {
    return {
      dialogFormVisible: false,
      form: {
        name: '',
        num: '',
        mail: ''
      },
      formLabelWidth: '200px'
    };
  },
  methods: {
    scrollToSection(sectionName) {
      const element = this.$refs[sectionName];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth', // 平滑滚动效果
          block: 'start' // 滚动到元素顶部
        });
      }
    },
    enterPage() {
      window.open('http://49.232.163.2:8085/', '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.center {
  width: 1602px;
  height: 100%;
  margin: 0 auto;
  padding: 120px 0 0;
}

.banner {
  height: 802px;
  width: 100%;
  background: #000;
  float: left;
  background: url("./images/banner.png");
  position: relative;

  .area {
    width: 600px;
    height: 220px;
    background: rgba(99, 162, 255, 0.72);
    position: absolute;
    top: 200px;
    left: 150px;
    padding: 35px;

    .title_1 {
      font-size: 30px;
      font-weight: bold;
      color: #fff;

    }

    .title_2 {
      font-size: 20px;
      color: #fff;
      margin: 20px 0 15px;
    }

    .describe {
      color: #fff;
      line-height: 24px;
    }
  }

  .nav {
    width: 100%;
    height: 90px;
    background: transparent;
    position: fixed;
    transition: background 0.3s ease;
    color: #ccc;
    z-index: 999;
  }

  .opaque {
    background: rgba(255, 255, 255, 1);
    color: #000;
    z-index: 999;
  }

  ul {
    width: 1000px;
    height: 100%;
    float: right;
    list-style: none;

    li {
      width: 100px;
      line-height: 90px;
      float: left;
      text-align: center;
      transition: background 0.3s ease, color 0.3s ease;
    }

    li:hover {
      background: rgba(50, 70, 100, 0.5);
      color: #fff;
      cursor: pointer;
    }
  }
}

.main {
  width: 100%;
  float: left;

  ul {
    display: block;
    height: 559px;
    list-style: none;

    li {
      width: 310px;
      height: 559px;
      border: 2px solid #9ec5ff;
      border-radius: 10px;
      margin-right: 13px;
      float: left;
      padding: 39px 30px;
      position: relative;
      overflow: hidden;

      img {
        height: 100px;
        margin: 0 auto;
        display: block;
        margin-bottom: 50px;
      }

      span {
        color: #63a2ff;
        font-size: 22px;
        line-height: 48px;
        letter-spacing: 2px;
        text-indent: 2em;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 7;
        overflow: hidden;
      }

      .mask {
        border-radius: 10px;
        position: absolute;
        bottom: -100%;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        transition: transform 0.3s ease;

        padding: 30px;
        color: #63a2ff;
        font-size: 22px;
        line-height: 48px;
        letter-spacing: 2px;
        text-indent: 2em;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

    }

    li:last-child {
      margin-right: 0;
    }

    li:hover .mask {
      transform: translateY(-100%);
    }
  }

  .enterPage {
    margin: 0 auto;
    width: 410px;
    height: 104px;
    background: #63a2ff;
    font-size: 44px;
    line-height: 104px;
    color: #fff;
    text-align: center;
    border-radius: 10px;
    margin: 63px auto 119px;
    cursor: pointer;
  }

  .introduce {
    width: 100%;
    background: #daedff;
    float: left;

    .center {
      width: 1602px;
      height: 100%;
      background: #daedff;
      margin: 0 auto;
      padding: 120px 0 0;
    }

    .article {
      height: 495px;
    }

    .article:last-child {
      height: 550px;
    }

    .left {
      padding: 50px;
      width: 801px;
      height: 495px;
      background: transparent;
      float: left;

      .title {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .content {
        width: 680px;
        font-family: "黑体";
        font-size: 18px;
        font-weight: bold;
        color: #666;
        letter-spacing: 2px;
        text-indent: 2em;
        line-height: 36px;
      }

      .btn {
        width: 300px;
        height: 76px;
        border-radius: 10px;
        background: #63a2ff;
        font-size: 32px;
        line-height: 76px;
        color: #fff;
        text-align: center;
        margin: 80px 200px;
      }
    }

    .right {
      width: 801px;
      float: left;
      background: transparent;

      img {
        width: 756px;
        height: 495px;
      }

      .btn {
        width: 300px;
        height: 76px;
        border-radius: 10px;
        background: #63a2ff;
        font-size: 32px;
        line-height: 76px;
        color: #fff;
        text-align: center;
        margin: 80px 200px;
      }
    }
  }

  .partner {
    width: 100%;
    background: #fff;
    float: left;

    .center {
      width: 1602px;
      height: 100%;
      background: #fff;
      margin: 0 auto;
      padding: 120px 0 0;

      .collaborationMode {
        margin: 0 auto;
        width: 1328px;
        height: 441px;
        background: url("./images/partner.png");
        position: relative;
        margin-bottom: 200px;

        .square {
          padding: 20px;

          img {
            margin: 0 auto;
            display: block;
            margin-bottom: 20px;
          }

          .title {
            font-size: 20px;
            text-align: center;
            font-weight: bold;
            margin-bottom: 30px;
          }

          .content {
            font-size: 16px;
            letter-spacing: 2px;
            text-indent: 2em;
            line-height: 30px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
            overflow: hidden;
          }
        }

        .square:nth-child(1) {
          background: #fff;
          width: 442px;
          height: 386px;
          position: absolute;
          top: 25px;
          left: -100px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
          border-radius: 5px;
        }

        .square:nth-child(2) {
          background: #fff;
          width: 442px;
          height: 386px;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: 25px auto 0;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
          border-radius: 5px;
        }

        .square:nth-child(3) {
          background: #fff;
          width: 442px;
          height: 386px;
          position: absolute;
          top: 25px;
          right: -100px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
          border-radius: 5px;
        }

        .enterPage {
          margin: 0 auto;
          width: 274px;
          height: 82px;
          background: url("./images/partner.png") no-repeat;
          background-size: 100% 100%;
          font-size: 34px;
          line-height: 82px;
          color: #fff;
          text-align: center;
          border-radius: 10px;
          margin: 63px auto 119px;
          cursor: pointer;
          position: absolute;
          top: 420px;
          left: 0;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
}

.footer {
    height: 500px;
    width: 100%;
    background: #161f24;
    float: left;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      padding: 0;

      .left {
        height: 400px;
        float: left;
        padding: 50px 0;
        background: transparent;

        img {
          display: block;
          margin-bottom: 50px;
        }

        span {
          line-height: 30px;
          color: #fff;
          display: block;
        }
      }

      .right {
        height: 400px;
        float: right;
        padding: 50px 0;
        background: transparent;

        img {
          width: 200px;
          height: 200px;
          display: block;
          margin-bottom: 20px;
        }

        span {
          margin-left: 45px;
          color: #fff;
          font-size: 18px;
          font-weight: bold;
        }
      }

      .bottom {
        width: 100%;
        height: 100px;
        float: left;
        text-align: center;
        color: #666;
        line-height: 100px;
      }
    }

  }
</style>